import React from "react";

type JsonLdScriptProps = {
  type: string;
  rawDatas?: object;
};

const JsonLdScript = (props: JsonLdScriptProps) => {
  return (
    <script
      type={"application/ld+json"}
      dangerouslySetInnerHTML={{
        __html: JSON.stringify({
          "@context": "https://schema.org",
          "@type": props.type,
          ...props.rawDatas,
        }),
      }}
    />
  );
};

export default JsonLdScript;
